import {
  JobsConfigurationCommand,
  JobsConfigurationJob
} from "modules/system/sections/plt/field-management/rings/rollout-package/configure/jobs/dtos";
import { useJobsFormOperations } from "modules/system/sections/plt/field-management/rings/rollout-package/configure/jobs/jobs.hooks";

import { confirm, IconButton } from "@bps/fluent-ui";
import { usePermissionsCheckQuery } from "@libs/api/gateways/env/env-gateway.hooks";
import { NO_ACTION_PERMISSION } from "@libs/permissions/permissions.constants";
import { Permissions } from "@libs/permissions/permissions.enum";

const confirmDeleteCommand = async () => {
  const isConfirmed = await confirm({
    confirmButtonProps: {
      text: "Delete"
    },
    cancelButtonProps: {
      text: "Cancel"
    },
    dialogContentProps: {
      title: "Delete this command?",
      subText: "Are you sure you want to delete this command?"
    }
  });
  return isConfirmed;
};

interface CommandDeleteButtonProps {
  job: JobsConfigurationJob;
  command: JobsConfigurationCommand;
}

export const CommandDeleteButton = ({
  job,
  command
}: CommandDeleteButtonProps) => {
  const { data: hasWritePermission } = usePermissionsCheckQuery(
    Permissions.PltFieldManagementWrite
  );

  const { deleteCommand } = useJobsFormOperations();

  return (
    <IconButton
      onClick={async () => {
        if (await confirmDeleteCommand()) deleteCommand(command, job);
      }}
      styles={{
        root: {
          background: "transparent",
          color: "red"
        }
      }}
      iconProps={{ iconName: "Cancel" }}
      disabled={!hasWritePermission}
      title={!hasWritePermission ? NO_ACTION_PERMISSION : undefined}
    />
  );
};
